import { HookBindings, HookComponentData, HookParser } from 'ngx-dynamic-hooks';
import { PrismicCheckmarkComponent } from '../components/prismic-checkmark.component';

export class CheckmarksParser implements HookParser {
  public findHookElements(contentElement: HTMLElement): HTMLElement[] {
    return Array.from(contentElement.querySelectorAll('check'));
  }

  public loadComponent(): HookComponentData {
    return {
      component: PrismicCheckmarkComponent,
    };
  }

  public getBindings(): HookBindings {
    return {};
  }
}
